@let topClasses = 'fixed top-0 left-1/2 z-[2000] -translate-x-1/2 opacity-0 pointer-events-none btn btn-secondary';
@let inlineClasses = 'absolute left-0 top-0 z-[2000] -translate-y-full opacity-0 pointer-events-none btn btn-secondary';

<button
    type="button"
    role="link"
    [class]="placement() === 'inline' ? inlineClasses : topClasses"
    [class.relative]="placement() === 'inline' && focused()"
    [class.left-auto]="placement() === 'inline' && focused()"
    [class.top-auto]="placement() === 'inline' && focused()"
    [class.translate-y-0]="placement() === 'inline' && focused()"
    [class.top-4]="placement() === 'top' && focused()"
    [class.opacity-100]="focused()"
    [class.pointer-events-auto]="focused()"
    (focus)="focused.set(true)"
    (blur)="focused.set(false)"
    (click)="onSkipLinkClick($event, targetId())"
>
    <span class="text-nowrap">{{ labelKey() | translate }}</span>
</button>
